import { Row, Button, Card, Col, Form, Input, Space, Spin, Typography } from 'antd'
import Styles from './DownloadMobileAppCard.module.css'

const { Text, Title, Link, Paragraph } = Typography

const DownloadMobileAppCard = () => {
    return (
        <Card bordered={false} className={Styles.container}>
            <Row justify={'center'} className={Styles.gap15}>
                <Title level={2} className={Styles.subTitle}>
                    Download the CURE App
                </Title>

                <Col>
                    <Text className={Styles.subText}>
                        Your resources are just a tap away!
                    </Text>
                    <Text className={Styles.subText}>
                        Download the CURE app today to get started.
                    </Text>
                </Col>
                <Row align={'middle'} className={`${Styles.gap15} ${Styles.gapLg0}`}>
                    <Col span={24} lg={12} >
                        <Row justify={'center'} className={Styles.h100}>
                            <Col flex={'280px'}>
                                <img alt="logo" width={'100%'} className="logo" src="https://www.cure.com/images/phone_stacked.png" />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24} lg={{ span: 0 }}>
                        <Text className={Styles.footerText}>
                            What are you waiting for?
                        </Text>
                        <Text className={Styles.footerText}>
                            Download Now!
                        </Text>
                    </Col>
                    <Col span={24} lg={12}>
                        <Row justify={'center'} className={`${Styles.h100} ${Styles.gap15}`}>
                            <Col className={`${Styles.appStoreIcon}`}>
                                <Link href="https://apps.apple.com/us/app/cure-auto-insurance/id1640122356" target="_blank">
                                    <img alt="logo" width={'100%'} className="logo" src="https://www.cure.com/images/store_appstore.png" />
                                </Link>
                            </Col>
                            <Col lg={24} />
                            <Col className={`${Styles.appStoreIcon}`}>
                                <Link href="https://play.google.com/store/apps/details?id=com.vazkordev.CureApp&hl=en-US" target="_blank">
                                    <img alt="logo" width={'100%'} className="logo" src="https://www.cure.com/images/store_googleplay.png" />
                                </Link>
                            </Col>
                        </Row>

                    </Col>
                </Row>
            </Row>
        </Card >
    )
}

DownloadMobileAppCard.propTypes = {}

export default DownloadMobileAppCard